export default "__VITE_ASSET__D7UU8LAh__"